





















































































import { Component, Vue } from 'vue-property-decorator';
import Landing from '../components/Landing.vue';

@Component({
  components: {
    Landing,
  },
})
export default class Home extends Vue {
}
